import { Stack, colors } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import Close from '@zet/design-system/svg/Close'
import { DEVICE_HEIGHT } from '@zet/utils/Constants'
import { ModalComponentProp } from 'react-native-modalfy'

import { ModalStackParams } from './modalConfig'

type Props = ModalComponentProp<ModalStackParams, void, 'WebVideoPlayerModal'>
const WebVideoPlayerModal = ({ modal: { closeModal, getParam } }: Props) => {
  const videoId = getParam('videoId')
  return (
    <Pressable style={{ maxHeight: DEVICE_HEIGHT - 100 }} onPress={closeModal}>
      <Stack className="bg-tertiary-200 items-end border">
        <Close color={colors.neutral.white100} size={40} />
      </Stack>
      <iframe
        width={'350vh'}
        height={'500vh'}
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      ></iframe>
    </Pressable>
  )
}

export default WebVideoPlayerModal
